/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

import type { AccountHoldsSlice, AccountIdAction, DataAction } from "./types";
import type { HoldsPayload } from "../../../../types/models/v1";

const initialState: AccountHoldsSlice = {
  byId: {},
};

function prepare(accountId: API.AccountId): AccountIdAction;
function prepare(accountId: API.AccountId, data: HoldsPayload): DataAction;
function prepare(accountId: API.AccountId, data?: HoldsPayload) {
  return { payload: { accountId, ...data } };
}

const subSlice = <A extends AccountIdAction>(
  state: AccountHoldsSlice,
  action: A,
) => {
  const { accountId } = action.payload;

  if (!state.byId) state.byId = {};
  if (!state.byId[accountId])
    state.byId[accountId] = { isFetching: false, holds: [] };

  return state.byId[accountId];
};

const accountHoldsSlice = createSlice({
  name: "accountHolds",
  initialState,
  reducers: {
    request: {
      prepare,
      reducer: (state, action: AccountIdAction) => {
        const sub = subSlice(state, action);
        sub.isFetching = true;
      },
    },
    fail: {
      prepare,
      reducer: (state, action: AccountIdAction) => {
        const sub = subSlice(state, action);
        sub.isFetching = false;
      },
    },
    receive: {
      prepare,
      reducer: (state, action: DataAction) => {
        const { holds } = action.payload;
        const sub = subSlice(state, action);
        sub.isFetching = false;
        sub.holds = holds;
      },
    },
  },
});

export default { [accountHoldsSlice.name]: accountHoldsSlice.reducer };
export const { actions } = accountHoldsSlice;
